import { styled } from '@mui/material';
import CTAButton from '@components/CTAButton';

export const VoiceActionButton = styled('button')(
  {
    width: 36,
    height: 36,
    borderRadius: '50%',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:disabled': {
      cursor: 'default',
    },
    '& svg': {
      width: 18,
      height: 18,
      color: '#fff',
    },
  },
  ({ theme, variant = 'default' }) => ({
    backgroundColor: variant === 'danger'
      ? theme.palette.error.main
      : theme.palette.novotalk.$actionButtonColor,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: variant === 'danger'
        ? theme.palette.error.main
        : theme.palette.novotalk.$actionButtonColorHover,
    },
    '&:active': {
      backgroundColor: variant === 'danger'
        ? theme.palette.error.main
        : theme.palette.novotalk.$actionButtonColorActive,
    },
    '&:disabled': {
      backgroundColor: theme.palette.novotalk.$buttonColorDisabled,
      color: theme.palette.common.white,
    },
  }),
);

export const VoiceActionCTA = styled(CTAButton)({
  width: 128,
  height: 44,
});

export const VoicePreview = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flexGrow: 0,
  maxWidth: 260,
});

export const VoiceButtonLoader = styled('span')(
  {
    display: 'inline-block',
    width: 14,
    height: 14,
    borderRadius: '50%',
    border: '2px solid currentColor',
    borderRightColor: 'transparent',
    animation: 'ntkSpin 0.7s linear infinite',
    marginRight: 8,
    verticalAlign: 'middle',
    '@keyframes ntkSpin': {
      from: { transform: 'rotate(0deg)' },
      to: { transform: 'rotate(360deg)' },
    },
  },
);

export const RecordingPanel = styled('div')(
  {
    flexGrow: 1,
    minHeight: 44,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 12px',
    gap: 12,
    marginRight: 8,
  },
  ({ theme }) => ({
    backgroundColor: theme.palette.novotalk.$messagingOthersMessageColor,
    border: `1px solid ${theme.palette.novotalk.$borderColorLight}`,
  }),
);

export const RecordingInfo = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  minWidth: 0,
});

export const RecordingDot = styled('span')(
  {
    width: 10,
    height: 10,
    borderRadius: '50%',
    flexShrink: 0,
    animation: 'ntkRecordPulse 1s ease-in-out infinite',
    '@keyframes ntkRecordPulse': {
      '0%': { transform: 'scale(0.9)', opacity: 0.6 },
      '50%': { transform: 'scale(1.1)', opacity: 1 },
      '100%': { transform: 'scale(0.9)', opacity: 0.6 },
    },
  },
  ({ theme }) => ({
    backgroundColor: theme.palette.error.main,
  }),
);

export const RecordingMeta = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

export const RecordingDuration = styled('div')({
  fontSize: 12,
  lineHeight: '16px',
  opacity: 0.85,
});
